(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentAssessControllers')
        .controller('RiskSelfAssessmentAssessController', Controller);

    Controller.$inject = ['$state', 'topBarService', 'govProcess', 'isAssessor'];

    function Controller($state, topBarService, govProcess, isAssessor) {
        topBarService.setTitleAndIcon(govProcess.DisplayName, 'fa fa-umbrella');

        if ($state.is('riskSelfAssessmentAssess.noActiveProcess') || $state.is('riskSelfAssessmentAssess.noRisksToAssess')) return;

        if (!$state.is('riskSelfAssessmentAssess.noActiveProcess') && !govProcess) {
            $state.go('riskSelfAssessmentAssess.noActiveProcess', {}, { location: 'replace' });
            return;
        }

        if (!$state.is('riskSelfAssessmentAssess.noRisksToAssess') && !isAssessor.IsAssessor) {
            $state.go('riskSelfAssessmentAssess.noRisksToAssess', {}, { location: 'replace' });
            return;
        }
    }
})();
